import React, { useEffect, createElement } from "react";
export const SignUpForm = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.innerHTML = `
      try{
        var f = document.createElement("iframe");
        f.src = 'https://forms.zohopublic.eu/leanops/form/mvphubcolinkedin/formperma/xH6NabhgNPBagR3YXygWgL3jhKBDl11n4XkYRLYebgo?zf_rszfm=1';
        f.style.border="none";
        f.style.height="611px";
        f.style.width="90%";
        f.style.transition="all 0.5s ease";
        f.setAttribute("aria-label", 'Ready to Start Earning? (Starting at 150€/month)');
        var d = document.getElementById("zf_div_xH6NabhgNPBagR3YXygWgL3jhKBDl11n4XkYRLYebgo");
        d.appendChild(f);
        window.addEventListener('message', function (){
          var evntData = event.data;
          if( evntData && evntData.constructor == String ){
            var zf_ifrm_data = evntData.split("|");
            if ( zf_ifrm_data.length == 2 || zf_ifrm_data.length == 3 ) {
              var zf_perma = zf_ifrm_data[0];
              var zf_ifrm_ht_nw = ( parseInt(zf_ifrm_data[1], 10) + 15 ) + "px";
              var iframe = document.getElementById("zf_div_xH6NabhgNPBagR3YXygWgL3jhKBDl11n4XkYRLYebgo").getElementsByTagName("iframe")[0];
              if ( (iframe.src).indexOf('formperma') > 0 && (iframe.src).indexOf(zf_perma) > 0 ) {
                var prevIframeHeight = iframe.style.height;
                var zf_tout = false;
                if( zf_ifrm_data.length == 3 ) {
                  iframe.scrollIntoView();
                  zf_tout = true;
                }
                if ( prevIframeHeight != zf_ifrm_ht_nw ) {
                  if( zf_tout ) {
                    setTimeout(function(){
                      iframe.style.height = zf_ifrm_ht_nw;
                    },500);
                  } else {
                    iframe.style.height = zf_ifrm_ht_nw;
                  }
                }
              }
            }
          }
        }, false);
      }catch(e){}
    `;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <section id="signup" className="w-full bg-gray-50 py-16" data-id="element-237">
      <div className="max-w-4xl mx-auto px-4" data-id="element-238">
        <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-239">
          <h2 className="text-3xl font-bold text-center mb-8" data-id="element-240">
            Ready to Start Earning?
          </h2>
          <div id="zf_div_xH6NabhgNPBagR3YXygWgL3jhKBDl11n4XkYRLYebgo" className="flex justify-center" data-id="element-241" />
        </div>
      </div>
    </section>;
};